import type { Inquiry, InquiryOfType } from "../Inquiry.js";
import { InquiryType } from "../InquiryType.js";
import type { InquiryEditInput, InquiryEditInputOfType } from "../private/InquiryEditInput.js";
import type { InquiryCreateInput, InquiryCreateInputOfType } from "../public/InquiryCreateInput.js";

export const inquiryTypeField = {
	[InquiryType.Wedding]: "weddingDetail",
	[InquiryType.CustomCake]: "customCakeDetail",
} satisfies Record<InquiryType, keyof Inquiry>;

export function isInquiryCreateInputOfType<Type extends InquiryType>(
	inquiry: InquiryCreateInput,
	type: Type,
): inquiry is InquiryCreateInputOfType<Type> {
	return inquiry.type === type && inquiry[inquiryTypeField[type]] !== undefined;
}

export function isInquiryEditInputOfType<Type extends InquiryType>(
	inquiry: InquiryEditInput,
	type: Type,
): inquiry is InquiryEditInputOfType<Type> {
	return inquiry[inquiryTypeField[type]] !== undefined;
}

export function isInquiryOfType<Type extends InquiryType>(
	inquiry: Inquiry,
	type: Type,
): inquiry is InquiryOfType<Type> {
	return inquiry.type === type && inquiry[inquiryTypeField[type]] !== undefined;
}
